import { createContext } from 'react';
import {
  FONT_FAMILY,
  FONT_SIZE,
  LETTER_SPACING,
  LINE_HEIGHT,
  PAGE_MARGIN,
  THEME,
} from 'constants/contentStyling/defaults'; // Trying to import from 'constants' will break here. Import ordering issue?

const BookAppearanceValuesContext = createContext({
  fontFamily: FONT_FAMILY,
  fontSize: FONT_SIZE,
  letterSpacing: LETTER_SPACING,
  lineHeight: LINE_HEIGHT,
  pageMargin: PAGE_MARGIN,
  theme: THEME,
  lastFontSizeWasFit: false,
  previousFontSize: FONT_SIZE,
  themeBackgroundColor: { r: 0, g: 0, b: 0 },
});

export default BookAppearanceValuesContext;
